import styled from 'styled-components';

export const StyledCover = styled.img`
  object-fit: cover;
  width: 100%;
  height: inherit !important;
`

export const StyledLogo = styled.img`
  width: 150px;
  height: auto;
`

export const ContainerLogo = styled.div`
  position: absolute;
  top: 16px;
  right: 41px;
`
